import Flickity from 'flickity';
import imagesLoaded from 'flickity-imagesloaded';
import flickitySync from 'flickity-sync';
import '../../../../../node_modules/flickity/css/flickity.css';
import $ from 'jquery';

$(() => {

	const $gallery = $('.gallery-slider__slides');
	const $nums = $('.gallery-slider__nums');
	const $slides = $('.gallery-slider__slide');

	if ($gallery.length === 0) return;

	const gallerySlider = new Flickity($gallery[0], {
		pageDots: false,
		cellAlign: 'left',
		prevNextButtons: false,
		imagesLoaded: true,
		sync: $nums[0]
	});

	const numSlider = new Flickity($nums[0], {
		pageDots: false,
		cellAlign: 'left'
	});

	numSlider.on('staticClick', (event, pointer, el, index) => {
		if (index !== undefined) {
			gallerySlider.select(index);
		}
	});

	gallerySlider.on('change', (index) => {
		const title = $slides.eq(index).attr('data-title');
		const subtitle = $slides.eq(index).attr('data-subtitle');
		$('.gallery-slider__title').text(title);
		$('.gallery-slider__subtitle').text(subtitle);
	});
});